import { ApiRetailerPaymentType } from '@vend/types'
import { useCallback } from 'react'

// TODO: Implement BigCommerce payment handling, it should open the BigCommerce Giftcard modal
export const useHandleBigCommercePayment = (amountTendered: string) => {
  const handleBigCommercePayment = useCallback(
    (paymentType: ApiRetailerPaymentType) => {},
    []
  )
  return {
    handleBigCommercePayment,
  }
}
